import axios, { AxiosResponse } from "axios";
import { processAxiosError } from "../processAxiosError";
import { ITlfItemReturn } from "./patchTlfItem";
import { tlfPreProcess } from "./tlfPreProcess";

export interface LoadTlfItemByIdDetails {
  id: string;
  azsolId?: string;
}

/**
 * Fetches a TLF item by its ID with optional azsolId and supports request cancellation.
 *
 * @param backEndUrl - Base backend URL
 * @param tlfItemVersion - An object containing the TLF item ID and optional azsolId
 * @param controller - Abort controller for request cancellation
 * @returns A promise that resolves to the processed TLF item or null if not found.
 */
export const loadTlfItemById = async (
  backEndUrl: string,
  tlfItemVersion: LoadTlfItemByIdDetails,
  controller?: AbortController,
): Promise<ITlfItemReturn> => {
  const url = `${backEndUrl}TlfItems/ById/${tlfItemVersion.id}${tlfItemVersion.azsolId ? `/${tlfItemVersion.azsolId}` : ""}`;

  try {
    const response: AxiosResponse = await axios.get(
      url,
      controller !== undefined ? { signal: controller.signal } : undefined,
    );
    return { success: true, data: tlfPreProcess(response.data) };
  } catch (error: unknown) {
    return processAxiosError("Get tlfItem failed", error);
  }
};
